import React, { Component } from "react";
import RZAudioPanel from "./../../fragments/RZAudioPanel";
import RZDNDPanel from "./../../fragments/RZDNDPanel";
import RZLanguagePanel from "./../../fragments/RZLanguagePanel";
import RZAccountPanel from "./../../fragments/RZAccountPanel";
import { AlexaCommon } from "./../../utils/Common";
import SynapseWebServiceSettings from "settings/AlexaWebService.json";
import { LocalizationContext } from "localization-context";
import "./../../css/Settings.scss";

const autoBind = require("auto-bind");

/**
 *
 * @param {React.Component} Component
 * @description Render Prop Pattern
 * @see https://stackoverflow.com/questions/49870098/how-to-get-the-data-from-react-context-consumer-outside-the-render
 */
const WithContext = (Component) => {
  return (props) => (
    <LocalizationContext.Consumer>
      {(value) => <Component {...props} localizationContext={value} />}
    </LocalizationContext.Consumer>
  );
};

class Settings extends React.Component {
  shortcutKey = {};
  constructor(props) {
    super(props);
    autoBind(this);
    this.avsWrapper = this.props.avsWrapper;

    this.state = {
      alexaStatus: true,
      languageData: undefined,
      audioDeviceData: undefined,
      alexaApplicationSoundData: undefined,
      alexaDisplayCardLayoutData: undefined,
      shouldShowContent: false,
    };
    //ref
    this.audioRef = React.createRef();
  }

  handleOnAlexaStatusChange(newAlexaStatus) {
    this.setState({
      alexaStatus: newAlexaStatus,
    });
  }

  handleOnLanguageChange(newCurrentLanguage) {
    //https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Spread_syntax
    console.log(this.state.languageData);
    this.setState(
      (prevState) => ({
        languageData: {
          ...prevState.languageData,
          active: newCurrentLanguage,
        },
      }),
      () => {
        //[NODEJS CALL]
        AlexaCommon.nodeCallUpdateLocale(
          this.state.languageData,
          this.avsWrapper.avs.token
        ).then(() => {
          if (!this.state.languageData) {
            return;
          }
          //Update Cloud.
          if (typeof window.SynapseMessenger !== "undefined") {
            //window.SynapseMessenger.setToBE("Language",)
            let sendingStr = AlexaCommon.makeSynapseStringValueOnlyFromJsonObj(
              this.state.languageData
            );
            AlexaCommon.consoleLogDataToSynpase(
              "Language string is sending to Synapse",
              sendingStr
            );
            window.SynapseMessenger.setToBE("Language", sendingStr);
          }
        });
      }
    );
  }

  /**
   * @description
   * RZDNDPanel component data change
   */
  handleAlexaApplicationSoundDataChange(newStatus) {
    this.setState(
      (prevState) => ({
        alexaApplicationSoundData: {
          ...prevState.alexaApplicationSoundData,
          [SynapseWebServiceSettings.Enable_Key]: newStatus,
        },
      }),
      () => {
        window.rzevent.triggerEvent(
          window.rzevent.EventTypes.APP_SOUNDS_CHECKED,
          this.state.alexaApplicationSoundData[
            SynapseWebServiceSettings.Enable_Key
          ]
        );
        AlexaCommon.consoleLogDataUIImportantInfo(
          "APP_SOUNDS_CHECKED event is called",
          this.state.alexaApplicationSoundData[
            SynapseWebServiceSettings.Enable_Key
          ]
        );
      }
    );
  }

  /**
   * @description
   * RZDNDPanel component data change.
   */

  handleAlexaDisplayCardLayoutDataChange(newStatus) {
    this.setState(
      (prevState) => ({
        alexaDisplayCardLayoutData: {
          ...prevState.alexaDisplayCardLayoutData,
          [SynapseWebServiceSettings.Enable_Key]: newStatus,
        },
      }),
      () => {
        window.rzevent.triggerEvent(
          window.rzevent.EventTypes.DISPLAY_CARDS_CHECKED,
          this.state.alexaDisplayCardLayoutData[
            SynapseWebServiceSettings.Enable_Key
          ]
        );
        AlexaCommon.consoleLogDataUIImportantInfo(
          "DISPLAY_CARDS_CHECKED event is called",
          this.state.alexaDisplayCardLayoutData[
            SynapseWebServiceSettings.Enable_Key
          ]
        );
      }
    );
  }

  subscribeEvents() {
    var that = this;
    window.rzevent.listenEvent(
      window.rzevent.EventTypes.RESPONSE_SYNAPSE_DATA,
      "1",
      (data = {}) => {
        that.onResponseSynapseData(data);
      }
    );
  }

  onResponseSynapseData(data) {
    let alexaJsonObj = AlexaCommon.parseSynapseStringToJsonObj(data);
    //Get AlexaStatus Data
    let alexaStatusDataObj = AlexaCommon.getSynapseApplicationSettingObj(
      alexaJsonObj
    );
    let alexaStatus = alexaStatusDataObj
      ? alexaStatusDataObj[SynapseWebServiceSettings.Enable_Key]
      : false;
    //Get AlexaApplicationSound Data
    let alexaApplicationSoundObj = AlexaCommon.getSynapseApplicationSoundObj(
      alexaJsonObj
    );
    //Get AlexaDisplayCardLayout Data
    let alexaDisplayCardLayoutObj = AlexaCommon.getSynapseDisplayCardLayoutObj(
      alexaJsonObj
    );
    //Get Language Data
    let alexaLanguageObj = AlexaCommon.getSynapseSettingsLanguageObj(
      alexaJsonObj
    );
    AlexaCommon.consoleLogDataFromSynpase(
      "result of getSynapseSettingsLanguageObj()",
      alexaLanguageObj
    );
    let updatedAlexaLanguageObj = this.updateLanguageDataBySynapseDataWhenAvailable(
      alexaLanguageObj
    );
    // //Get DND data
    // let alexaDNDObj = AlexaCommon.getSynapseSettingsDNDObj(alexaJsonObj);
    //   //Get Audio Device data
    let audioDeviceObj = AlexaCommon.getSynapseSettingsAudioDeviceObj(
      alexaJsonObj
    );
    AlexaCommon.consoleLogDataFromSynpase(
      "result of audioDeviceObj",
      JSON.stringify(audioDeviceObj)
    );
    this.setState(
      {
        languageData: updatedAlexaLanguageObj,
        audioDeviceData: audioDeviceObj,
        alexaStatus: alexaStatus,
        alexaApplicationSoundData: alexaApplicationSoundObj,
        alexaDisplayCardLayoutData: alexaDisplayCardLayoutObj,
      },
      () => {
        //[NODEJS CALL]
        //Init AVS value by Synpase Data.
        AlexaCommon.nodeCallUpdateLocale(
          this.state.languageData,
          this.avsWrapper.avs.token
        );
        this.setState(
          {
            shouldShowContent: true,
          },
          () => {
            AlexaCommon.consoleLogDataUIImportantInfo(
              "Now Settings page can show",
              this.state.shouldShowContent
            );
          }
        );
      }
    );
  }

  updateLanguageDataBySynapseDataWhenAvailable(languageDataObj) {
    let newLanguageDataObj;
    if (!languageDataObj) {
      return newLanguageDataObj;
    }
    newLanguageDataObj = languageDataObj;
    //if active === default, set to US
    if (languageDataObj.active === SynapseWebServiceSettings["Default_Value"]) {
      if (
        SynapseWebServiceSettings.hasOwnProperty(
          this.props.localizationContext.getLanguage()
        )
      ) {
        newLanguageDataObj.active = this.props.localizationContext.getLanguage();
      } else {
        newLanguageDataObj.active =
          SynapseWebServiceSettings["Default_Language_Key"];
      }
    }
    return newLanguageDataObj;
  }

  //override
  componentDidMount() {
    //register listen first
    //init event
    this.subscribeEvents();
    //request Page Data from Synapse 3
    window.rzevent.triggerEvent(window.rzevent.EventTypes.REQUEST_SYNAPSE_DATA);
    console.log(`${window.rzevent.EventTypes.REQUEST_SYNAPSE_DATA} was sent`);
  }

  render() {
    let contents = (
      <div className="settings-root-1 alexa-flex-row-center-jleft alexa-content-wrapper">
        <div className="settings-responsive-wrapper-1 alexa-flex-column-jleft">
          <RZDNDPanel
            key="dnd"
            alexaStatus={this.state.alexaStatus}
            alexaApplicationSoundData={this.state.alexaApplicationSoundData}
            alexaDisplayCardLayoutData={this.state.alexaDisplayCardLayoutData}
            handleOnAlexaStatusChange={this.handleOnAlexaStatusChange}
            handleAlexaApplicationSoundDataChange={
              this.handleAlexaApplicationSoundDataChange
            }
            handleAlexaDisplayCardLayoutDataChange={
              this.handleAlexaDisplayCardLayoutDataChange
            }
          />
          <RZAudioPanel
            key="audio"
            ref={this.audioRef}
            avsWrapper={this.props.avsWrapper}
            audioDeviceData={this.state.audioDeviceData}
            alexaStatus={this.state.alexaStatus}
          />
          <RZLanguagePanel
            key="language"
            avsWrapper={this.avsWrapper}
            languageData={this.state.languageData}
            handleOnLanguageChange={this.handleOnLanguageChange}
            alexaStatus={this.state.alexaStatus}
          />
          <RZAccountPanel key="account" avsWrapper={this.avsWrapper} />
        </div>
      </div>
    );

    let isDiplaySettingPanelClassName = this.state.shouldShowContent
      ? ""
      : "alexa-none";

    return (
      <LocalizationContext.Consumer>
        {(values) => (
          <div className="logged-in-container" style={{ marginRight: "2px" }}>
            <div
              className={isDiplaySettingPanelClassName}
              style={{ position: "relative", height: "auto", width: "100%" }}
            >
              <div className="settings-container">
                <div className="settings-wrapper">
                  {contents}
                  <div className="widget rztooltip">
                    <div className="help" />
                    <div className="tip">
                      <span>{values.settingsToolTip1}</span>
                      <br style={{ lineHeight: "30px" }} />
                      <span>{values.settingsToolTip2}</span>
                      <br style={{ lineHeight: "0px" }} />
                      <span>{values.settingsToolTip3}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </LocalizationContext.Consumer>
    );
  }
}

export default WithContext(Settings);
